import { ChoiceModalController } from './choice-modal.controller';

const ngModule = angular.module('bb.choice-modal', ['ui.bootstrap']);

ngModule.controller('ChoiceModalController', ChoiceModalController);

export default ngModule;
